import { GetString } from 'fluent-react';
import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { rootFontSize } from '../../cssVariables';
import { googleAnalyticsEvent } from '../../useGoogleAnalytics';
import { gridSmallMediaSize } from '../Grid';
import { HeightAttr } from './Dropdown';
import Selector from './index';

const searchBarHeight = 2.5; // in rem
export const menuMaxHeight = 200; // in px
export const offsetValue = 0 - menuMaxHeight + (searchBarHeight * rootFontSize);

const CountrySelectorContainer = styled.div`
  width: 100%;
  height: 100%;
  cursor: pointer;
  position: absolute;
`;

interface Props {
  selectedCountry: string;
  onCountrySelect: (country: string) => void;
  getFluentString: GetString;
}
const CountrySelector = (props: Props) => {
  const {
    selectedCountry, onCountrySelect,
    getFluentString,
  } = props;

  const elRef = useRef<HTMLDivElement | null>(null);
  // width is in rem
  const [width, setWidth] = useState<number | undefined>(undefined);
  useEffect(() => {
    const {current: el} = elRef;
    if (el !== null) {
      const rect = el.getBoundingClientRect();
      const measuredWidth = Math.floor(rect.width);
      setWidth(measuredWidth / rootFontSize);
    }
  }, []);

  const conclusionCountrySelect = (country: string) => {
    onCountrySelect(country);
    googleAnalyticsEvent('Country Profiles Conclusion Country Select', `click -- new country selected ${country}`);
  };

  const fontSize = window.innerWidth > gridSmallMediaSize ? 1.5 : 0.6;

  const selector = (width === undefined) ? null : (
    <Selector
      selectedCountry={selectedCountry}
      onCountrySelect={conclusionCountrySelect}
      getFluentString={getFluentString}
      promptText={''}
      useTriggerButton={true}
      visualProps={{
        magnifyingGlassWidth: 1.6,
        magnifyingGlassGap: 0.625,
        magnifyingGlassColor: '#5b5b5b',
        placeholderTextColor: '#333',
        searchBarHeight: 100,
        searchBarHeightUnit: '%',
        placeholderMarginBottom: 0,
        placeholderMarginTop: 0,
        totalWidth: width,
        menuMaxHeight,
        fontSize: fontSize + 'rem',
        heightAttr: HeightAttr.Height,
        backgroundColor: 'transparent',
      }}
      helpTooltipIndex={0}
      isHelpActive={false}
    />
  );
  return (
    <CountrySelectorContainer ref={elRef}>
      {selector}
    </CountrySelectorContainer>
  );
};

export default CountrySelector;
